import styled from 'styled-components';

const PageTitle = styled.div`
  padding: ${({ theme }) => `0 0 ${theme.spacing(8)}`};
`;

export default PageTitle;
